import React from 'react';
import PropTypes from 'prop-types';

import ExploreStoryHeaderContent from './explore-story-header-content';

const ExploreStoryHeaderOriginal = ({
  coverImage,
  coverImageThumb,
  location,
  title,
  rank,
  author,
  date,
  nominatedAuthor,
  theme
}) => (
  <div className='bc-explore-story__header-background'>
    <ExploreStoryHeaderContent
      theme={theme}
      location={location}
      author={author}
      rank={rank}
      coverImage={coverImage}
      title={title}
      coverImageThumb={coverImageThumb}
      nominatedAuthor={nominatedAuthor}
      date={date} />
  </div>
);

ExploreStoryHeaderOriginal.defaultProps = {
  rank: 0,
  nominatedAuthor: null,
  theme: 'mint'
};

ExploreStoryHeaderOriginal.propTypes = {
  coverImage: PropTypes.string.isRequired,
  coverImageThumb: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  rank: PropTypes.number,
  nominatedAuthor: PropTypes.string,
  theme: PropTypes.string
};

export default ExploreStoryHeaderOriginal;
